import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaseModal } from 'shared/abstract/base-modal';
import { SafeHtmlPipe } from 'shared/pipes/safeHtml.pipe';

@Component({
    selector: 'app-info-confirmation-modal',
    templateUrl: './info-confirmation-modal.component.html',
    styleUrls: ['../modal.component.scss'],
    imports: [TranslateModule, NgClass, SafeHtmlPipe],
})
export class InfoConfirmationModalComponent extends BaseModal {
    public data!: {
        title: string;
        body: string;
        type: 'top' | 'side' | 'center';
    };

    constructor() {
        super();
    }

    public close(result: boolean): void {
        this.closeModalInstance(result);
    }
}
